export default {
  newRecipe: 'Neues Rezept',
  protectedTooltip: 'Dieses Rezept kann nicht bearbeitet werden, da es sich um ein geschütztes Rezept handelt.',
};
